import { JsonApiQuery } from '@nx-icilalune/data/access';

const filters = { ['menuInternalId']: 'secondary-menu' };
export const secondaryMenuQuery: JsonApiQuery = {
  queryId: 'secondaryMenu',
  type: 'menuLinks',
  fields: {},
  filters,
};
